import React from 'react';
import { motion } from 'framer-motion';
import './Gallery.css';

const Gallery = () => {
  const galleryImages = [
    { id: 1, src: "/images/gallery/clinic_interior.png", alt: "Clinic Interior" },
    { id: 2, src: "/images/gallery/treatment_room.png", alt: "Treatment Room" },
    { id: 3, src: "/images/gallery/acne_treatment.png", alt: "Acne Treatment" },
    { id: 4, src: "/images/gallery/botox_treatment.png", alt: "Botox Treatment" },
    { id: 5, src: "/images/gallery/laser_hair_removal.png", alt: "Laser Hair Removal" },
    { id: 6, src: "/images/gallery/hair_fall_control.png", alt: "Hair Fall Control" },
  ];

  return (
    <section id="gallery" className="gallery section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Visual Journey</h2>
          <p className="section-subtitle">Explore our clinic and see the results of our transformative treatments.</p>
        </motion.div>

        <motion.div
          className="gallery-grid"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1, transition: { staggerChildren: 0.1 } }}
          viewport={{ once: true }}
        >
          {galleryImages.map((image) => (
            <motion.div
              key={image.id}
              className="gallery-item"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4 }}
              viewport={{ once: true }}
            >
              <img src={image.src} alt={image.alt} />
              <div className="gallery-overlay">
                <p>{image.alt}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Gallery;
